(() => {
  if (customElements.get('load-more-button')) return;

  class LoadMoreButton extends HTMLElement {
    connectedCallback() {
      this._btn = this.querySelector('button');
      this._controller = null;
      this._fetchId = 0; // version token — guards against stale resolved responses
      if (!this._btn) return;
      this._btn.addEventListener('click', this._load.bind(this));
    }

    disconnectedCallback() {
      // Invalidate any in-flight response AND cancel the request.
      // Incrementing _fetchId covers the rare race where a fetch resolves just
      // before facets.js replaces the grid — the stale .then() callback will
      // see a mismatched id and bail out before touching the DOM.
      this._fetchId++;
      this._controller?.abort();
    }

    _setLoading(on) {
      this._btn.disabled = on;
      this._btn.setAttribute('aria-busy', String(on));
      this.classList.toggle('is-loading', on);
    }

    _showError() {
      let msg = this.querySelector('[data-error]');
      if (!msg) {
        msg = document.createElement('p');
        msg.dataset.error = '';
        msg.setAttribute('role', 'alert');
        msg.style.cssText = 'text-align:center;margin-top:1rem;font-size:0.85em;';
        this.append(msg);
      }
      // Error text is set via data-error-text on the element (translated by Liquid).
      msg.textContent = this.dataset.errorText || 'Error loading products.';
    }

    _load() {
      const nextUrl = this.dataset.nextUrl;
      if (!nextUrl) return;

      const id = ++this._fetchId; // snapshot current version
      this._controller = new AbortController();
      this._setLoading(true);

      fetch(nextUrl, { signal: this._controller.signal })
        .then((res) => {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.text();
        })
        .then((html) => {
          // Stale-response guard: if disconnectedCallback fired (facets replaced the
          // grid) between the fetch and this resolution, _fetchId will have been
          // incremented and id will no longer match — discard silently.
          if (id !== this._fetchId) return;

          const doc = new DOMParser().parseFromString(html, 'text/html');

          // Grab the live grid — bail out if it has been replaced by facets.js
          const currentGrid = document.querySelector('#product-grid');
          if (!currentGrid) return;

          const newGrid = doc.querySelector('#product-grid');
          if (newGrid) {
            Array.from(newGrid.children).forEach((item) =>
              currentGrid.appendChild(item)
            );
          }

          // Update for next page, or remove button when catalog is exhausted
          const nextBtn = doc.querySelector('load-more-button');
          if (nextBtn?.dataset.nextUrl) {
            this.dataset.nextUrl = nextBtn.dataset.nextUrl;
            this._setLoading(false);
          } else {
            this.remove();
          }
        })
        .catch((err) => {
          if (err.name === 'AbortError') return; // silently ignore — intentional cancel
          this._setLoading(false);
          this._showError();
        });
    }
  }

  customElements.define('load-more-button', LoadMoreButton);
})();
